import { render, staticRenderFns } from "./backOut.vue?vue&type=template&id=bbc805c8&scoped=true&"
import script from "./backOut.vue?vue&type=script&lang=js&"
export * from "./backOut.vue?vue&type=script&lang=js&"
import style0 from "./backOut.vue?vue&type=style&index=0&id=bbc805c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc805c8",
  null
  
)

export default component.exports